export interface RecentItem {
  id: number;
  title: string;
  subtitle: string;
  at: string | null;
  withTime: boolean;
  status: string;
  amount: number | null;
}

export interface RecentLists {
  agendamentosRecentes: RecentItem[];
  orcamentosRecentes: RecentItem[];
  sinistrosRecentes: RecentItem[];
  ordensRecentes: RecentItem[];
}

export function mapRecents(source: any): RecentLists {
  return {
    agendamentosRecentes: mapList(source, 'agendamentosRecentes', 'AgendamentosRecentes'),
    orcamentosRecentes: mapList(source, 'orcamentosRecentes', 'OrcamentosRecentes'),
    sinistrosRecentes: mapList(source, 'sinistrosRecentes', 'SinistrosRecentes'),
    ordensRecentes: mapList(source, 'ordensRecentes', 'OrdensRecentes')
  };
}

export function formatRecentWhen(iso: string | null, withTime: boolean): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const day = date.toLocaleDateString('pt-BR');
  if (!withTime) return day;
  const time = date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  return `${day} ${time}`;
}

export function formatRecentAmount(amount: number | null): string {
  if (amount == null) return '';
  return amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function recentStatusTone(status: string): string {
  const value = (status || '').toLowerCase();
  if (value.includes('agend')) return 'tone-amber';
  if (value.includes('pend')) return 'tone-orange';
  if (value.includes('aprov')) return 'tone-green';
  if (value.includes('orcam')) return 'tone-cyan';
  if (value.includes('abert')) return 'tone-blue';
  if (value.includes('exec') || value.includes('andam')) return 'tone-violet';
  if (value.includes('cancel') || value.includes('recus')) return 'tone-slate';
  return 'tone-slate';
}

function mapList(source: any, camel: string, pascal: string): RecentItem[] {
  const raw = source?.[camel] ?? source?.[pascal] ?? [];
  if (!Array.isArray(raw)) return [];
  return raw.map((item: any) => ({
    id: Number(item?.id ?? item?.Id ?? 0),
    title: String(item?.title ?? item?.Title ?? '—'),
    subtitle: String(item?.subtitle ?? item?.Subtitle ?? ''),
    at: item?.at ?? item?.At ?? null,
    withTime: Boolean(item?.withTime ?? item?.WithTime),
    status: String(item?.status ?? item?.Status ?? ''),
    amount: item?.amount == null && item?.Amount == null ? null : Number(item?.amount ?? item?.Amount)
  }));
}
